/**
 * 用户心愿
 *
 * api: https://mock.memeyule.com/project/218/interface/api/24350
 *
 * @author lianghua.fu
 * @date 2026-01-16 16:32:45
 */

import { hoc, request } from '@/lib';
import { UiToast } from 'components';
import PopupWish from './popup-wish';
import PopupEnter from './popup-enter';

let index = 3000;

export const vcToastMsg = (data) => {
  // data = {
  //   data: {
  //     id: 20846017,
  //     nickname: '20846017',
  //     pic: 'https://test-img.sumeme.com/23/7/1516764526295.jpg',
  //     content: 'Hello, world!',
  //     timestamp: 1768484986265,
  //     index: index--
  //   },
  //   action: 'wish.publish',
  // };

  console.log('vcToastMsg', data);

  // 主播接收发布内容
  if (data.action === 'wish.publish') {
    data.index = index;
    index--;

    hoc.render(data, PopupWish);
  }
  //   主播承接心愿
  if (data.action === 'wish.accept') {
  }

  //   用户进房
  if (data.action === 'wish.enter') {
    hoc.render(data, PopupEnter);
  }
};

const acceptUserWish = (id) => {
  request.vc
    .post('/vc/api/v1/wish/accept', {
      id,
    })
    .then(() => {
      UiToast.text('已承接心愿，请等待用户确认！');
    })
    .catch((res) => {
      UiToast.warn(res.msg);
    });
};

export default {
  acceptUserWish,
};
